import React from "react";
import { getFallbackMakeLogoImage } from "../../utils/carLogo/getFallbackMakeLogoImage";
import ModelDetails from "./ModelDetails";

const FilterCard = ({ filter, onDelete }) => {
  const logoUrl = getFallbackMakeLogoImage(filter.name);

  return (
    <div style={styles.card}>
      <div style={styles.header}>
        <img
          src={logoUrl}
          alt={filter.name}
          style={styles.logo}
        />
        <h3 style={styles.title}>
          {filter.name}
          <button onClick={onDelete} style={styles.deleteButton}>
            x
          </button>
        </h3>
      </div>
      {Array.isArray(filter.models) && filter.models.length > 0 ? (
        filter.models.map((model) => (
          <ModelDetails key={model.id_car_model} model={model} />
        ))
      ) : (
        <div style={styles.noModels}>Nema modela</div>
      )}
    </div>
  );
};

export default FilterCard;

const styles = {
  card: {
    border: "1px solid #dcdcdc",
    borderRadius: 10,
    padding: 16,
    marginBottom: 20,
    maxWidth: 420,
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: 12,
  },
  logo: {
    width: 80,
    height: 80,
    objectFit: "contain",
    marginRight: 12,
  },
  title: {
    margin: 0,
    display: "flex",
    alignItems: "center",
  },
  deleteButton: {
    marginLeft: 10,
    backgroundColor: "white",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    fontSize: 12,
  },
  noModels: {
    fontStyle: "italic",
  },
};
